import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { connectProjectsEntrypoint } from '@atlassian/jira-spa-apps-connect-projects/entrypoint.tsx';
import { jiraHorizontalNavEntrypoint } from '@atlassian/jira-horizontal-nav/entrypoint.tsx';

export const connectProjectsPageEntrypoint = createPageEntryPoint({
	main: connectProjectsEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
	horizontalNavigation: jiraHorizontalNavEntrypoint,
});

export const connectProjectsWithoutHorizontalNavPageEntrypoint = createPageEntryPoint({
	main: connectProjectsEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
